// extracted by mini-css-extract-plugin
export var cardHeader = "card-header_aA8rO_GRkS7MOUxXfA2X";
export var cardIcon = "card-icon_QY8MLMOWWvTXzDyageNo";
export var cardsRow = "cards-row_Q3B9ZId3ZePbDZs0jal4";
export var checkIcon = "check-icon_xLo8bXjVFGB_Spbf5F16";
export var checkItem = "check-item_ol0G_fVo3DmWVopGCKyT";
export var getStartedContainer = "get-started-container_cypJtWwxQW1iU0qYrhbk";
export var infoCard = "info-card_ct6SXR_o3d2ik9hd8csq";
export var samlSection = "saml-section_d4wt9199EkxCkaX66oQU";